import { render, staticRenderFns } from "./ProductsStockSidebar.vue?vue&type=template&id=2fb19665"
import script from "./ProductsStockSidebar.vue?vue&type=script&lang=js"
export * from "./ProductsStockSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProductsStockSidebar.vue?vue&type=style&index=0&id=2fb19665&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports